export class ContactEditDTO { // TODO ask if I need to provide all fields
    public address: string
    public country: string
    public gender: string
    public postal_code: string
    public city: string
    public last_name: string
    public first_name: string
    public phone_number: string
    public phone_code: string
    public subscribe_newsletter?: boolean = false
    public cgos_agent_id?: string
    constructor(
        address: string,
        country: string,
        gender: string,
        postal_code: string,
        city: string,
        last_name: string,
        first_name: string,
        phone_number: string,
        phone_code: string,
        subscribe_newsletter?: boolean,
        cgos_agent_id?: string
    ) {
        this.address = address
        this.country = country
        this.gender = gender
        this.postal_code = postal_code
        this.city = city
        this.last_name = last_name
        this.first_name = first_name
        this.phone_number = phone_number
        this.phone_code = phone_code
        this.subscribe_newsletter = subscribe_newsletter
        this.cgos_agent_id = cgos_agent_id
    }
}
